module.exports = __webpack_public_path__ + "static/media/sportsequip.177f861a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/sportsequip.svg
// module id = 3067
// module chunks = 0